<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">{{ $t("countries") }}</div>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina')">Argentina</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/australia')">Australia</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/chile')">Chile</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france')">France</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/germany')">Germany</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/italy')">Italy</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/new-zealand')">New Zealand</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/portugal')">Portugal</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/south-africa')">South Africa</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/spain')">Spain</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/usa')">USA</nuxt-link>
                </div>

                <v-select
                    :items="items"
                    v-model="select"
                    label="Please choose"
                    single-line
                    item-text="report"
                    item-value="src"
                    return-object
                    class="show-mobile"
                    v-on:change="changeRoute"
                ></v-select>
                <div class="wine-guide-right">
                    <div class="howto-title hide-mobile">{{ $t("home-top4") }}</div>
                    <div class="howto-title show-mobile">{{ $t("wineguide") }}</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">{{ $t("wineguide1") }}</div>
                    <div class="howto-text-img"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Wineguide",
        head() {
            return {
                title: 'World wine guide | Vindome Wine Guide',
                meta: [
                    {
                        hid: 'description',
                        name: 'description',
                        content: 'Welcome to the world of our wine guide. Browse the world’s greatest fine wine regions for more information on what to buy, what to keep and what to drink.'
                    }
                ],
                bodyAttrs: {
                    class: this.classNames
                }
            }
        },
        data () {
            return {
                classNames: 'wine-guide inner-page',
                select: { report: 'Please choose', src: '#' },
                items: [
                    { report: 'Argentina', src: '/wine-guide/argentina' },
                    { report: 'Australia', src: '/wine-guide/australia' },
                    { report: 'Chile', src: '/wine-guide/chile' },
                    { report: 'France', src: '/wine-guide/france' },
                    { report: 'Germany', src: '/wine-guide/germany' },
                    { report: 'Italy', src: '/wine-guide/italy' },
                    { report: 'New Zealand', src: '/wine-guide/new-zealand' },
                    { report: 'Portugal', src: '/wine-guide/portugal' },
                    { report: 'South Africa', src: '/wine-guide/south-africa' },
                    { report: 'Spain', src: '/wine-guide/spain' },
                    { report: 'USA', src: '/wine-guide/usa' }
                ]
            }
        },
        methods: {
            changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
        },
        mounted() {
            this.classNames = this.classNames + (this.$route.query.mobile ? ' inner-page-app mobile-app' : '')
        }
    }
</script>

<style scoped>
    .howto-text-img {
        background: url('../../assets/map.png') no-repeat center top;
        margin-top: 80px;
        height: 600px;
        width: 100%;
    }

    .howto-title {
        margin-top: 31px;
        font-size: 38px;
        line-height: 24px;
        font-weight: 700;
        color: #024E7B;
    }
    .howto-separator {
        width: 50px;
        height: 3px;
        background-color: #E5C57B;
        margin: 40px 0;
    }
    .howto-text {
        margin-bottom: 80px;
    }
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Poppins', sans-serif;
    }
    .wine-guide-body {
        padding-top: 35px;
    }
    .wine-guide-left {
        width: 300px;
        display: inline-block;
    }
    .wine-guide-right {
        display: inline-block;
        width: calc(100% - 305px);
        vertical-align: top;
    }
    .wine-guide-left-title {
        font-weight: 600;
        color: #024E7B;
        font-size: 18px;
        height: 57px;
        line-height: 57px;
    }
    .wine-guide-country {
        display: block;
        height: 57px;
        line-height: 57px;
        text-decoration: none;
        color: #000;
        font-size: 16px;
        padding-left: 30px;
        width: 260px;
        border-left: 3px solid transparent;
    }
    .wine-guide-country:hover {
        border-color: #024E7B;
        background: #E5EDF2;
    }
    .show-mobile {
        display: none;
    }

    @media (width: 1024px) {
        .howto-text-img {
            height: 560px;
            background-size: contain;
        }
    }

    @media (max-width: 767px) {
        .howto-text-img {
            height: 230px;
            background-size: contain;
        }
    }
</style>

<style>
    .mobile-app .cc_dialog.headline,
    .mobile-app .header-container,
    .mobile-app .main-footer,
    .wine-guide #iubenda-cs-banner  {
        display: none !important;
    }
    .smartbanner-show .mobile-app .smartbanner {
        display: none !important;
        margin-top: 0 !important;
        height: 0 !important;
        background-color: red !important;
    }
    .smartbanner-show .mobile-app {
        margin-top: 0 !important;
    }
</style>
